import React from 'react'
import { useSelector } from 'react-redux'
import GridCard from './GridCard'
import labels from '../../configuration/labels'

import moment from 'moment'
import _ from 'lodash'

import '../../styles/scss/components/grid/grid-cards.scss'

const GridCards = () => {
  const activeDate = useSelector(state => state.filtersData.date)
  const activeCategory = useSelector(state => state.filtersData.category)
  const formattedDate = moment(activeDate).format('dddd, MMMM Do')
  const eventsData = useSelector(state => state.eventsData)

  let events = null
  let dailyEvents = []

  if (eventsData && eventsData.data && !_.isEmpty(eventsData.data.events)) {
    for (const eventKey in eventsData.data.events) {
      const currentEvent = eventsData.data.events[eventKey]

      if (currentEvent && currentEvent.title && currentEvent.schedule) {
        for (const scheduleKey in currentEvent.schedule) {
          if (
            moment(activeDate).isSame(currentEvent.schedule[scheduleKey].startDate, 'day')
          ) {
            const currentSchedule = currentEvent.schedule[scheduleKey]
            const startDate = _.get(currentSchedule, 'startDate', null)
            const endDate = _.get(currentSchedule, 'endDate', null)

            const formattedEvent = {
              ...currentEvent,
              activeDates: {
                startDate: startDate,
                endDate: endDate
              }
            }

            dailyEvents.push(formattedEvent)
            events = dailyEvents

            if (activeCategory !== '' && !_.isEmpty(events)) {
              let filteredEvents = []

              events.forEach(event => {
                if (_.includes(event.categories, activeCategory)) {
                  filteredEvents.push(event)
                }
              })

              events = filteredEvents
            }
          }
        }
      }
    }
  }

  let renderEventsCards = []

  if (!_.isEmpty(events)) {
    const sortedEvents = _.sortBy(events, function(o) { return new moment(o.activeDates.startDate) })

    for (const eventKey in sortedEvents) {
      renderEventsCards.push(
        <GridCard
          key={'grid-card-' + eventKey}
          activeDate={activeDate}
          eventData={sortedEvents[eventKey]}
        />
      )
    }
  }

  return (
    <div className="flow-events__grid-cards">
      <h6>
        Events For <span className="u-font-bold">{formattedDate}</span>
      </h6>

      {!_.isEmpty(renderEventsCards) ? (
        renderEventsCards
      ) : activeCategory !== '' ? (
        <p className="event-unavailable u-remove-margin">{labels.filteredEventsUnavailableMessage}</p>
      ) : (
        <p className="event-unavailable u-remove-margin">{labels.generalEventsUnavailableMessage}</p>
      )}
    </div>
  )
}

export default GridCards
